<template>
	<div class="modal-card vertical-scroll">
		<div class="main-section">
			<progress v-if="loading" class="progress is-small is-info" max="100">15%</progress>
			<div class="container">
				<div class="tabs mt-5">
					<ul>
						<li :class="sheetIndex == iSheet ? activeClass : ''" v-bind:key="sheet.sheetName"
							v-for="(sheet, sheetIndex) in dataSheet">
							<a @click="selectSheet(sheet.sheetName, sheetIndex)"> {{ sheet.sheetName }} </a>
						</li>
					</ul>
				</div>
				<div v-for="(sheet, sheetIndex) in dataSheet" v-bind:key="sheet.sheetName">
					<div class="table-container side_scroll" v-if="sheetIndex === iSheet">
						<table class="table is-hoverable is-fullwidth has-text-centered">
							<thead>
								<th colspan="1"><span class="nobreak">Primera fila</span>
									<br/><span class="nobreak">con datos</span>
								</th>
								<th colspan="100">{{ sheet.sheetName }}</th>
							</thead>
							<tbody>
								<tr :class="[{'row-odd': iRow % 2 === 1}, 'control']"
									v-for="(row, iRow) in sheet.data" v-bind:key="iRow">
									<td class="">
										<label class="radio" @click="selectRowHeader(iRow)">
											<input type="radio" name="answer" :checked="rowHeaderSelected[iSheet] === iRow">
										</label>
									</td>
									<td v-for="(cell, iCell) in row" v-bind:key="cell + ':' + iCell"
										style="text-overflow: ellipsis;" class="is-clipped"
										:class="iRow == rowHeaderSelectedSingle ? 'has-text-weight-bold' : ''">
										{{ cell }}
									</td>
								</tr>
								<tr class="no-hover-effect" v-for="asignacion, row in columnsHeaderNeeded" :key="asignacion">
									<td class="no-border"></td>
									<td v-for="(cell, col) in sheet.data[0]" :key="col"
										:class="['button-td', 'no-border']">
										<button @click="asignar(asignacion, row, col)"
											:class="['asigna-button',
											{ 'activo': isClicked[col * 4 + row + reservedXSheet * iSheet] },
											{'last-row': row == 3}, {'first-col': col == 0},
											{'released-button': isFlashing[col * 4 + row + reservedXSheet * iSheet]}]">
											{{ asignacion }}
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<div v-if="errors" class="error_messages">
				<div v-for="(error_msg, ierr) in error_messages" v-bind:key="ierr">
					{{ error_msg }}
				</div>
			</div>
			<button :class="['button', 'is-info', {'disabled': disabled == true}]" @click="saveFormat()" role="button">
				Grabar formato
			</button>
			<button class="button" @click="$emit('close-format')" aria-label="Cerrar Modal" role="button">
				Cancelar
			</button>
		</footer>
	</div>
</template>


<script>
import { getFirstRows, grabarConfiguracion } from "@/api/carteraAnalista";

export default {
	name: "FormatExcelModal",
	data() {
		return {
			errors: false,
			error_messages: [],
			disabled: false,
			loading: true,
			maxSheets: 50,
			reservedXSheet: 2000, //500 columns per sheet
			iSheet: 0,
			activeClass: "is-active",
			rowHeaderSelected: [],
			rowHeaderSelectedSingle: 0,
			dataSheet: [],
			isClicked: [],
			isClickedSwitch: [],
			isFlashing: [],
			isFlashingSwitch: [],
			columnsHeaderNeeded: [
				"Fecha",
				"Monto",
				"Contraparte",
				"Nro Doc."
			],
			maxWidth: 0,
		};
	},
	methods: {
		giantArray() {
			var result = new Array(this.reservedXSheet * this.maxSheets);
			for (var i = 0; i < this.reservedXSheet * this.maxSheets; i++) {
				result[i] = false;
			}
			return result;
		},
		async initData(spreadsheetData, sheetdex, fila, columnas) {
			spreadsheetData.map(gridData => {
				let iMaxDataColumn = 0
				gridData.data = gridData.data.map((row) => {
					row = row.map((cell, iCell) => {
						if (iMaxDataColumn < iCell && cell.length > 0) {
							iMaxDataColumn = iCell
						}
						if (cell.length > 50) {
							cell = cell.substring(0, 50)
							cell += "..."
						}
						return cell
					})
					return row
				})
				gridData.data = gridData.data.map((row) => {
					row = row.slice(0, iMaxDataColumn + 1)
					return row
				})
				this.maxWidth = iMaxDataColumn + 1;
			})
			this.dataSheet = spreadsheetData;
			this.loading = false;
			this.iSheet = sheetdex;
			this.rowHeaderSelected[this.iSheet] = fila;
			this.rowHeaderSelectedSingle = fila;
			for (const elem of columnas) {
				const pos = elem.col * 4 + elem.row + this.reservedXSheet * this.iSheet;
				this.isClicked[pos] = true;
				this.isClickedSwitch[pos] = true;
			}
			this.disabled = false;
		},
		selectSheet(newSheetName, sheetIndex) {
			this.iSheet = sheetIndex;
			this.rowHeaderSelectedSingle = this.rowHeaderSelected[this.iSheet];
		},
		selectRowHeader(iRowSheet) {
			this.rowHeaderSelectedSingle = iRowSheet;
			this.rowHeaderSelected[this.iSheet] = iRowSheet
		},
		selectName(y) {
			const values = ["fecha", "monto", "contraparte", "nrodoc"];
			if (y >= 0 && y < values.length) {
				return values[y];
			}
			return "";
		},
		async saveFormat() {
			if (this.disabled == true) {
				return;
			}
			this.disabled = true;
			this.errors = false;
			this.error_messages = [];
			const result = { "company": this.company, "hoja": this.iSheet,
				"fila": this.rowHeaderSelected[this.iSheet], columnas: [] };
			for (var yy = 0; yy < this.maxWidth; yy++){
				for (var xx = 0; xx < 4; xx++) {
					const pos = yy * 4 + xx + this.reservedXSheet * this.iSheet;
					if (this.isClicked[pos]) {
						const name = this.selectName(xx);
						result.columnas.push({"col": yy, "row": xx, "name": name});
					}
				}
			}
			const grabado = await grabarConfiguracion(this.formatData.id, result);
			if (grabado.data.status == 'error') {
				this.errors = true;
				this.error_messages = grabado.data.msg;
				setTimeout(() => {
					this.errors = false;
				}, 4000);
				this.disabled = true;
				setTimeout(() => {
					this.disabled = false;
				}, 2000);
			} else {
				this.disabled = false;
				this.$emit('close-format');
			}
		},
		async asignar(asignacion, x, y) {
			const pos = y * 4 + x + this.reservedXSheet * this.iSheet;
			const currVal = this.isClicked[pos];
			this.isClicked[pos] = !currVal;
			this.isClickedSwitch[pos] = !currVal;
			if (!currVal) { //a non clicked button was clicked on
				this.flash(x,y);
				//clean vertical
				for(var xx = 0; xx < 4; xx++) {
					const subpos = y * 4 + xx + this.reservedXSheet * this.iSheet;
					if (subpos != pos) {
						this.isClicked[subpos] = false;
						this.isClickedSwitch[subpos] = false;
					}
				}
				//clean horizontal
				for(var yy = 0; yy < this.maxWidth; yy++) {
					const subpos = yy * 4 + x + this.reservedXSheet * this.iSheet;
					if (subpos != pos) {
						this.isClicked[subpos] = false;
						this.isClickedSwitch[subpos] = false;
					}
				}
			}
			//always swap buffers around for reactivity
			//they both have the same values, this is silly but needed.
			//we could update the precise value with splice, but it would generate memory churn
			const tempIsClicked = this.isClicked;
			this.isClicked = this.isClickedSwitch;
			this.isClickedSwitch = tempIsClicked;
		},
		async flash(x, y) {
			for (var yy = 0; yy < this.maxWidth; yy++){
				for (var xx = 0; xx < 4; xx++) {
					const pos = yy * 4 + xx + this.reservedXSheet * this.iSheet;
					if ((xx == x || yy == y) && !(xx == x && yy == y)) {
						this.isFlashingSwitch[pos] = true;
					} else {
						this.isFlashingSwitch[pos] = false;
					}
					this.isFlashing[pos] = false;
				}
			}
			//this is a little different; isFlashing is all falses, so it's not flashing
			//isFlashingSwitch has the actual visible flashes
			//then in the timeout they are swapped around
			const tempFlash = this.isFlashing; //saving a buffer full of falses
			this.isFlashing = this.isFlashingSwitch; //buttons flash when deactivated
			setTimeout(() => {
				this.isFlashingSwitch = this.isFlashing;
				//isFlashingSwitch now has a buffer with some buttons marked as flashing
				//it's ok, they will be overwritten next time flash() is called
				this.isFlashing = tempFlash; //buttons stop flashing
			}, 200);
		}
	},
	mounted() {
		this.disabled = true;
		this.isFlashing = this.giantArray();
		this.isFlashingSwitch = this.giantArray();
		this.isClicked = this.giantArray();
		this.isClickedSwitch = this.giantArray();
		getFirstRows(this.formatData.id).then((response) => {
			if (response.data.status == 'error') {
				this.errors = true;
				this.error_messages = ['Error al recuperar la data desde Google Sheets'];
				this.disabled = true;
				setTimeout(() => {
					this.$emit('close-format');
				}, 3000);
			}
			if (response.data.format == null) {
				response.data.format = '{}';
			}
			const format = response.data.format.replaceAll("'", "\"");
			const jsonformat = JSON.parse(format);
			this.initData(response.data.list, jsonformat.hoja || 0, jsonformat.fila || -1, jsonformat.columnas || []);
		});
	},
	props: {
		company: {
			type: Number,
			default: 0
		},
		formatData: {
			type: Object,
			default: () => ({})
		}
	},

};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.modal-card {
	width: 100%;
	max-height: 86vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
}

// Cuerpo desplazable del modal (la preview de la planilla puede ser larga).
.main-section {
	flex: 1;
	overflow: hidden auto;
	background-color: var(--ap-paper);
	padding: 18px 22px 4px;
}

// Solapas de hojas: un solo acento (teal) en vez del azul de Bulma.
:deep(.tabs li.is-active a){
	color: var(--ap-teal);
	border-bottom-color: var(--ap-teal);
}

:deep(.tabs a){
	color: var(--ap-slate);
	transition: color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:hover {
		color: var(--ap-teal-deep);
		border-bottom-color: var(--ap-line-strong);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// Zebra tenue sobre la preview.
.row-odd {
	background-color: var(--ap-mist);
}

.first-col {
	margin-left: 4px;
}

.last-row {
	margin-bottom: 4px;
}

// Estado "liberado" (flash al deseleccionar): texto atenuado.
.released-button {
	color: var(--ap-muted) !important;
}

// Botones para asignar columna → campo. Chip neutro que vira a teal.
.asigna-button {
	white-space: nowrap;
	width: 6.8em;
	border: none;
	border-radius: var(--ap-radius-sm);
	font-weight: normal;
	color: var(--ap-ink);
	background: var(--ap-mist);
	box-shadow: var(--ap-shadow-card);
	transition: background-color 0.2s ease, color 0.2s ease,
		box-shadow 0.2s ease, transform 0.2s ease;

	&:hover {
		background-color: var(--ap-teal-wash);
		color: var(--ap-teal-deep);
		transform: translateY(-2px);
		box-shadow: var(--ap-shadow-pop);
	}

	&:active {
		background-color: var(--ap-teal-wash);
		transform: translateY(1px);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// Columna asignada: acento teal sólido (reemplaza el azul + amarillo).
.activo {
	background-color: var(--ap-teal) !important;
	color: var(--ap-paper);
	border-radius: var(--ap-radius-sm);
	font-weight: bold;
	box-shadow: 0 0 0 1px var(--ap-teal-deep) inset;
}

.activo:hover {
	background-color: var(--ap-teal-deep) !important;
	color: var(--ap-paper);
	transform: translateY(0) !important;
}

.button-td {
	padding: 0 !important;
}

.table.is-hoverable tr.no-hover-effect:hover {
	background-color: inherit; /* Or any specific color the row normally has */
}

.no-border {
	border: 0 !important;
}

.nobreak {
	white-space: nowrap;
}

// Radio de fila-header: foco accesible con el acento teal.
.radio input:focus-visible {
	outline: 2px solid var(--ap-teal);
	outline-offset: 2px;
}

// Caja de errores del backend: tono de alerta del tema.
.error_messages {
	border: 2px solid var(--ap-alert);
	border-radius: var(--ap-radius-sm);
	padding-top: 4px;
	padding-left: 8px;
	padding-bottom: 2px;
	padding-right: 20px;
	margin-right: 10px;
	z-index: 100;
	color: var(--ap-alert);
	background-color: var(--ap-alert-wash);
}

// Footer: borde superior + botón primario oscuro que vira a teal al hover.
:deep(.modal-card-foot){
	border-top: 1px solid var(--ap-line);

	.button.is-info {
		background-color: var(--ap-ink);
		border-color: transparent;
		color: var(--ap-paper);
		font-weight: 600;

		&:hover {
			background-color: var(--ap-teal-deep);
		}

		&:focus-visible {
			outline: 2px solid var(--ap-teal);
			outline-offset: 2px;
		}
	}

	.button.is-info.disabled {
		background-color: var(--ap-mist);
		color: var(--ap-muted);
		cursor: not-allowed !important;

		&:hover {
			background-color: var(--ap-mist);
			cursor: not-allowed !important;
		}
	}
}

.side_scroll {
	overflow-x: auto;
	white-space: nowrap;
	scrollbar-color: var(--ap-slate) var(--ap-mist);
	scrollbar-width: thin;
}
</style>
<style>
.vertical-scroll {
	overflow-y: auto;
	max-height: 800px;
}

</style>
